const COPY = {
  title:
    "Join our email list and stay connected to the centennial celebration.",
  social: true
};

const SOCIAL = [
  {
    icon: "/static/images/instagram.svg",
    url: "https://instagram.com",
    width: 23,
    height: 23
  },
  {
    icon: "/static/images/facebook.svg",
    url: "https://facebook.com",
    width: 23,
    height: 23
  },
  {
    icon: "/static/images/twitter.svg",
    url: "https://twitter.com",
    width: 28,
    height: 23
  },
  {
    icon: "/static/images/youtube.svg",
    url: "https://youtube.com",
    width: 28,
    height: 20
  }
];

export { COPY, SOCIAL };
